"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconSwitch = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Switch" }, props),
        react_1.default.createElement("title", null, "Switch"),
        react_1.default.createElement("path", { d: "M71.4 40.009L40.071 71.348 28.63 59.916l11.357-11.357H8.57V31.427h54.204l8.636 8.582", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M59.979 51.437l11.432-11.432L39.978 8.572 28.546 20.004l31.433 31.433z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M57.257 88.577h54.064V71.444H80.036l11.218-11.217L79.82 48.794l-31.2 31.2 8.636 8.583z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M60.05 68.56L48.62 79.99l31.433 31.434 11.432-11.433L60.051 68.56z", fill: "#000" })));
};
exports.default = BrandIconSwitch;
